import Collection from "../../data-structures/collection"
import Message from "./message"

const debug = false
// const debug = "MessagesCollection"

export default class MessagesCollection extends Collection<Message> {

    constructor(models: Message[]) {
        super(models)
    }

    static initFromJson(data: any): MessagesCollection {
        const models: Message[] = []

        _.map(data, (record: JSONObject) => {
            models.push(new Message(record))
        })

        return new MessagesCollection(models)
    }

    async add(model: Message, withApiCall: boolean = false) {
        super.add(model)
        // should be overridden to use 'withApiCall'
    }

    async addFromJson(data: any, withApiCall: boolean = false) {
        await this.add(new Message(data), withApiCall)
    }

    remove(id: ID, withApiCall: boolean = false): Message[] {
        // should be overridden to use 'withApiCall'
        return super.remove(id)
    }

    replace(id: ID, model: Message, withApiCall: boolean = false) {
        super.replace(id, model)
        // should be overridden to use 'withApiCall'
    }

    sort() {
        this.models = _.orderBy(this.models, [
            model=>model.momentCreated?.format('x'),
        ], ['asc'])
    }

    _updateMessagesRender() {
        const lastKey = this.models.length - 1
        let prevUserId: ID | undefined
        _.map(this.models, (message:Message, key:number)=>{
            message.render.isUserChanged    = prevUserId !== message.fromUserId
            message.render.isFirst          = key === 0
            message.render.isLast           = lastKey === key

            prevUserId = message.fromUserId
        })
    }

    update() {
        this.sort()
        this._updateMessagesRender()
    }
}
